import { useMutation } from "@apollo/client"
import { TOURNAMENT_CANCEL, TOURNAMENT_DELETE } from "../queries/tournamentCancel"
import { useToast } from "@/hooks/use-toast"

interface TournamentActionInput {
  tournamentId: number
}

export const useTournamentCancel = () => {
  const { toast } = useToast()

  const [tournamentCancelMutation, { loading: loadingCancel }] = useMutation(TOURNAMENT_CANCEL, {
    onCompleted: (data) => {
      if (data.TournamentCancel.status.success) {
        toast({
          title: "Torneo cancelado exitosamente",
          variant: "success",
          description: `El torneo ${data.TournamentCancel.Tournament.name} ha sido cancelado.`,
        })
      } else {
        toast({
          title: "Error al cancelar torneo",
          description: data.TournamentCancel.status.detail,
          variant: "destructive",
        })
      }
    },
    onError: (error) => {
      toast({
        title: "Error al cancelar torneo",
        description: error.message,
        variant: "destructive",
      })
    },
  })

  const [tournamentDeleteMutation, { loading: loadingDelete }] = useMutation(TOURNAMENT_DELETE, {
    onCompleted: (data) => {
      if (data.TournamentDelete.status.success) {
        toast({
          title: "Torneo eliminado exitosamente",
          variant: "success",
          description: `El torneo ha sido eliminado.`,
        })
      } else {
        toast({
          title: "Error al eliminar torneo",
          description: data.TournamentDelete.status.detail,
          variant: "destructive",
        })
      }
    },
    onError: (error) => {
      toast({
        title: "Error al eliminar torneo",
        description: error.message,
        variant: "destructive",
      })
    },
  })

  const tournamentCancel = async (input: TournamentActionInput) => {
    const result = await tournamentCancelMutation({
      variables: { TournamentCancelInput: input },
    })
    return result.data?.TournamentCancel
  }

  const tournamentDelete = async (input: TournamentActionInput) => {
    const result = await tournamentDeleteMutation({
      variables: { TournamentDeleteInput: input },
    })
    return result.data?.TournamentDelete
  }

  return { tournamentCancel, tournamentDelete, loadingCancel, loadingDelete }
}
